var common = angular.module("common", []);

common.run(['sentryService', function (sentryService) {
    sentryService.init();
}]);
